// src/App.js
import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import MisionVision from './components/MisionVision';  // ← nuevo
import Services from './components/Services';
import TechServices from './components/TechServices';
import About from './components/About';
import Innovation from './components/Innovation';
import TnB from './components/TnB';
import Clients from './components/Clients';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <MisionVision />
      <Services />
      <TechServices />
      <About />
      <Clients />
      <Innovation />
      <TnB />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;